'use client';

import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

interface ToastProviderProps {
  children: React.ReactNode;
}

export default function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <ToastContainer position="top-center" toastClassName="p-8" bodyClassName="gap-8 p-0 pr-1" stacked autoClose={5000000} />
    </>
  );
}
